"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncHookChain = void 0;
const react_1 = require("react");
const use_once_1 = require("./use-once");
function useAsyncHookChain(hooks, callback) {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    (0, use_once_1.useOnceAsync)(() => __awaiter(this, void 0, void 0, function* () {
        try {
            const values = yield Promise.all(hooks.map(hook => hook[3]));
            callback(...values);
        }
        catch (error) {
            setError(error);
        }
        finally {
            setLoading(false);
        }
    }));
    return [loading, error];
}
exports.useAsyncHookChain = useAsyncHookChain;
//# sourceMappingURL=use-async-hook-chain.js.map